(function () {
  'use strict';
  if (window.KTCartCombo) return;
 
  var COMBO_RE = /COMBO\s+(\d+)\s+POR\s+EL\s+PRECIO\s+DE\s+\$?\s*([\d.,]+)/i;
  var CENTS = 100; // Shopify entrega los importes en centavos (₡4.950 = 495000)
 
  function toNumber(value) {
    var n = Number(value);
    return isFinite(n) ? n : 0;
  }
 
  function parseAmount(text) {
    var digits = String(text).replace(/[^\d]/g, '');
    return digits ? Number(digits) : 0;
  }
 
  // "COMBO 2 POR EL PRECIO DE 9900" -> { size: 2, totalCents: 990000 }
  function parseCombo(title) {
    var match = COMBO_RE.exec(title || '');
    if (match) return { size: Number(match[1]) || 2, totalCents: parseAmount(match[2]) * CENTS };
    var onlySize = /(\d+)/.exec(title || '');
    return { size: onlySize ? Number(onlySize[1]) : 2, totalCents: 0 };
  }
 
  function formatMoney(cents) {
    return '₡ ' + (cents / CENTS).toLocaleString('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }
 
  function formatSubtotal(cents) {
    return '₡' + (cents / CENTS).toLocaleString('en-US', { minimumFractionDigits: 0, maximumFractionDigits: 0 }).replace(/,/g, '.');
  }
 
  function collect() {
    var entries = [];
    document.querySelectorAll('.kt-order-summary .kt-cart-item').forEach(function (row) {
      var checkbox = row.querySelector('.line-item__checkbox');
      var finalLine = toNumber(row.dataset.finalLinePrice);
      entries.push({
        row: row,
        quantity: toNumber(row.dataset.quantity),
        finalLine: finalLine,
        originalLine: toNumber(row.dataset.originalLinePrice) || finalLine,
        title: (row.dataset.comboTitle || '').trim(),
        labelled: row.dataset.comboLabelled === 'true', // Shopify ya aplicó el descuento a esta línea
        enabled: !!checkbox && !checkbox.disabled,
        selected: !!checkbox && checkbox.checked && !checkbox.disabled,
        discounted: 0,
        lineCents: 0
      });
    });
    return entries;
  }
 
  function priceCombos(entries) {
    var groups = {};
    entries.forEach(function (e) {
      if (e.title && e.selected) {
        var key = e.title.toUpperCase();
        (groups[key] = groups[key] || []).push(e);
      }
    });
 
    Object.keys(groups).forEach(function (key) {
      var list = groups[key];
      var combo = parseCombo(list[0].title);
      var size = Math.max(combo.size, 1);
      var units = list.reduce(function (sum, e) { return sum + e.quantity; }, 0);
      var remaining = Math.floor(units / size) * size; // unidades que sí completan combo
 
      var unitCombo = combo.totalCents > 0 ? combo.totalCents / size : Infinity;
      if (!isFinite(unitCombo)) {
        list.forEach(function (e) {
          if (e.quantity && e.finalLine < e.originalLine) unitCombo = Math.min(unitCombo, e.finalLine / e.quantity);
        });
        if (!isFinite(unitCombo)) remaining = 0;
      }
 
      list.forEach(function (e) {
        var d = Math.min(e.quantity, remaining);
        remaining -= d;
        e.discounted = d;
        var originalPerUnit = e.quantity ? e.originalLine / e.quantity : 0;
        var promoPart = Math.min(Math.round(d * unitCombo), Math.round(originalPerUnit * d));
        var fullPart = Math.round(originalPerUnit * (e.quantity - d));
        e.lineCents = promoPart + fullPart;
      });
 
      // Si TODAS las líneas habilitadas de este combo están seleccionadas y completas,
      // se respetan los importes exactos que calculó Shopify.
      var allEnabledSameCombo = entries.filter(function (e) { return e.enabled && e.title.toUpperCase() === key; });
      var fullSet = allEnabledSameCombo.length === list.length &&
        list.every(function (e) { return e.labelled && e.discounted === e.quantity; });
      if (fullSet) list.forEach(function (e) { e.lineCents = e.finalLine; });
    });
  }
 
  function show(el, visible) {
    if (el) el.style.display = visible ? '' : 'none';
  }
 
  function applyToDom(entries) {
    entries.forEach(function (e) {
      if (!e.title) return;
      var row = e.row;
      var plain = row.querySelector('[data-ktc-plain]');
      var promoJs = row.querySelector('[data-ktc-promo-js]');
      var label = row.querySelector('[data-ktc-label]');
      var natives = row.querySelectorAll('[data-ktc-native]');
      var discounts = row.querySelector('[data-ktc-discounts]');
      if (!plain || !promoJs) return;
 
      // native: línea de otro grupo (deshabilitada) -> se deja como la entrega Shopify
      // promo:  seleccionada y completa el combo (precio calculado aquí)
      // plain:  deseleccionada, o seleccionada sin completar el combo
      var mode = !e.enabled ? 'native' : (e.selected && e.discounted > 0 ? 'promo' : 'plain');
 
      natives.forEach(function (el) { show(el, mode === 'native'); });
      show(plain, mode === 'plain');
      show(promoJs, mode === 'promo');
      show(label, mode === 'promo');
 
      if (discounts) {
        discounts.querySelectorAll('li:not([data-ktc-label])').forEach(function (li) {
          if (/COMBO/i.test(li.textContent)) show(li, mode === 'native');
        });
      }
 
      if (mode === 'promo' && e.quantity) {
        var strong = promoJs.querySelector('.cart-item__final-price');
        var old = promoJs.querySelector('.cart-item__old-price');
        if (strong) strong.textContent = formatMoney(Math.round(e.lineCents / e.quantity));
        if (old) old.textContent = formatMoney(Math.round(e.originalLine / e.quantity));
      }
    });
  }
 
  function evaluate(options) {
    var entries = collect();
    priceCombos(entries);
 
    var subtotal = 0;
    var original = 0;
    var selectedLines = [];
    entries.forEach(function (e) {
      if (!e.selected) return;
      if (!e.title) e.lineCents = e.finalLine;
      subtotal += e.lineCents;
      original += e.originalLine;
      selectedLines.push({
        row: e.row,
        quantity: e.quantity,
        lineCents: e.lineCents,
        originalLineCents: e.originalLine,
        isCombo: !!e.title,
        discountedUnits: e.discounted
      });
    });
 
    if (!options || options.apply !== false) applyToDom(entries);
 
    return {
      subtotal: subtotal,
      originalTotal: original,
      discount: original - subtotal,
      selectedLines: selectedLines
    };
  }
 
  // Clave estable de un checkbox: variante + propiedades de la línea (no su posición).
  // Así la selección guardada no se corre cuando entra un ítem nuevo al carrito.
  function checkboxKey(checkbox) {
    var row = checkbox && checkbox.closest ? checkbox.closest('.kt-cart-item') : null;
    if (!row || !row.dataset.variantId) return checkbox ? checkbox.id : '';
    return 'v' + row.dataset.variantId + '|' + (row.dataset.variantProperties || '');
  }
 
  window.KTCartCombo = {
    checkboxKey: checkboxKey,
    evaluate: evaluate,
    refresh: function () { return evaluate({ apply: true }); },
    formatSubtotal: formatSubtotal,
    parseCombo: parseCombo
  };
})();
 